<div [ngClass]="{ 'half-screen': selectedUser }" class="main-container">
    <app-list-header
        [title]="title"
        icon="person"
        [searchPlaceholder]="'users.search' | translate"
        [searchTerm]="searchTerm | async"
        (searchTermChange)="searchTerm.next($event); searchUsers()"
        (clearSearch)="clearFilter()"
        (addNewItem)="createNewUser()"
    ></app-list-header>

    <div class="table-container">
        <table class="table">
            <thead>
                <tr>
                    <th>{{ 'userDetails.displayname' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let user of filteredUsers | async"
                    (click)="select(user)"
                    [class.selected]="user === selectedUser"
                >
                    <td class="name-cell">{{ user.displayname }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
